var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TbcpIndex",class:{showNav:_vm.$route.query.hidenav!='true'&&_vm.$route.query.type!='Ztxx'&&_vm.$route.path != '/Res/Ztxx'}},[_c('series-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }